<template>
<div class="page"
     v-if="item" role="main">
  <component v-for="slice in body"
             :key="slice.id"
             :is="'slice'+slice.slice_type"
             :item="item"
             :slice="slice">
  </component>


</div>
</template>

<script>
export default {
  name: "Page",
  props: [ 'uid', 'type', 'lang', 'title'],
  data() {
    return {
      item: null
    }
  },
  watch: {
    'uid': {
      immediate: true,
      handler() {
        this.getContent()
      }
    }
  },
  computed: {
    needsHeader() {
      let first_slice = this.item.data.body[ 0 ]
      if ( first_slice && first_slice.slice_type == "header" ) {
        return false
      }
      return true
    },
    body() {
      if ( this.needsHeader ) {
        return [ {
          slice_type: "headline",
          tone: 'normal'
        }, ...this.item.data.body ]
      }
      return this.item.data.body
    }
  },
  methods: {
    getContent() {
      let type = this.type || 'page'
      this.$prismic.client.getByUID( type, this.uid, {
        lang: this.language,
      } ).then( response => {
        if ( response ) {
          this.item = response
        } else {
          this.$router.replace( "/not-found" )
        }
      } );
    },
  },
  metaInfo() {
    return {
      title: this.item ? this.$prismic.asText(this.item.data.title) : "Loading...",
      link: [{rel: 'canonical', href: 'https://hungerfreeamerica.org'+ this.$route.fullPath}]
    }
  },
};
</script>
<style scoped lang="scss">
.page {
    display: grid;
    grid-gap: 2rem;
}
</style>
